import { t } from 'ttag'

export const budgetRounds = () => [
  {
    name: () => t`Location `,
    roundId: -1,
    id: 'location',
    hideFromStepper: true,
    visibleMenu: false
  },
  {
    name: () => t`Housing `,
    roundId: 0,
    id: 'housing',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Utilities`,
    roundId: 1,
    id: 'utility',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Food`,
    roundId: 2,
    id: 'food',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Entertainment`,
    roundId: 3,
    id: 'entertainment',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Clothes`,
    roundId: 4,
    id: 'clothes',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Transport`,
    roundId: 5,
    id: 'transportation',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Insurance`,
    roundId: 6,
    id: 'healthinsurance',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Education`,
    roundId: 7,
    id: 'education',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Savings`,
    roundId: 8,
    id: 'savings',
    hideFromStepper: false,
    visibleMenu: true
  },
  {
    name: () => t`Other`,
    roundId: 9,
    id: 'other',
    hideFromStepper: true,
    visibleMenu: false
  }
]

export const fmtCurrency = inp =>
  (inp || 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
